import { useState } from 'react';

import SelfieTutoiral from './SelfieTutorial';
import SelfieCamera from './SelfieCamera';

type TPageMode = 'tutorial-upload-file' | 'camera';

function Selfie() {
  const [mode, setMode] = useState<TPageMode>('tutorial-upload-file');

  return (
    <>
      {mode === 'tutorial-upload-file' && (
        <SelfieTutoiral onClickOpenCamera={() => setMode('camera')} />
      )}
      {mode === 'camera' && (
        <SelfieCamera
          onClickCloseCamera={() => setMode('tutorial-upload-file')}
        />
      )}
    </>
  );
}

export default Selfie;
